import ifvisible from 'ifvisible'

export function initializeTimings() {
  const {
    /* session, */
    activity
  } = (window.timings = {
    session: new Timer(),
    activity: new Timer()
  })

  // Track the active use, pausing when the user is idle or away
  const idleDuration = 60

  ifvisible.setIdleDuration(idleDuration)
  ifvisible.on('idle', (_) => activity.pause())
  ifvisible.on('wakeup', (_) => activity.resume())
  ifvisible.on('idle', (_) => {})
}

/**
 * Timer
 * =====
 * A pausable/resumable timer at millisecond granularity
 */
class Timer {
  constructor() {
    this.startTime = Date.now()
    this.elapsed = 0
  }

  /**
   * pause: Stop time
   */
  pause() {
    const now = Date.now()
    if (this.startTime) {
      this.elapsed += now - this.startTime
      this.startTime = false
    }
    return this
  }

  /**
   * resume: Resume time
   */
  resume() {
    if (!this.startTime) {
      this.startTime = Date.now()
    }
    return this
  }

  /**
   * duration: Retrieve the elapsed time since creating this timer
   */
  duration() {
    return this.elapsed + (this.startTime ? Date.now() - this.startTime : 0)
  }
}
